import React, { Fragment, useState, useEffect } from 'react'
import { Form, Button, Row, Col } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import Cookies from 'js-cookie'
import config from '../../config'
import { getRounds } from '../../services/config-services'
import swal from 'sweetalert2'

export default function AffiliateGenPayment() {
  const [rounds, setRounds] = useState([])
  const [roundDate, setRoundDate] = useState('')
  const dispatch = useDispatch()

  const handleClickDownloadFileTransfer = async () => {
    try {
      dispatch({ type: 'loading_show' })
      if(roundDate) {
        const params = new URLSearchParams({
          roundDate: roundDate,
        })
        await fetch(`${config.apiAdminGateway}/api/v1/admin/affiliates/file/transfer?${params.toString()}`, {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        }).then((response) =>  {
          if (response.status !== 200) throw new Error(response.status)
          return response.blob()
        })
        .then((blobData) => {
          const url = window.URL.createObjectURL(new Blob([blobData]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `download-${roundDate}.zip`)
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)
        })
      }
    } catch (error) {
      console.error(error)
      swal.fire({
        title: 'ไม่สามารถดาวน์โหลดได้\nเนื่องจากไม่มีข้อมูล',
        text: 'กรุณาลองใหม่อีกครั้ง',
        icon: 'error',
      })

    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  useEffect(() => {
    const fetchRounds = async () => {
      try {
        const response = await getRounds()
        if(response?.length > 0){
          const rounds = response[0]
          setRoundDate(rounds.value)
        }
        setRounds(response)
      } catch (error) {
        setRounds([])
      }
    }
    fetchRounds()
  }, [])

  return (
    <Fragment>
      <Row style={{ padding: '8px 0'}} >
        <Col sm={12}>
          <Form>
            <Form.Group>
              <Row>
                <Col sm={12}>
                  <Row>
                    <Col md={4} lg={4}>
                      <div
                        style={{ display: 'flex' }}
                      >
                        <span style={{ width: '15%', alignContent: 'center'}}>งวดที่ :</span>
                        <select
                          className="form-control"
                          style={{ width: '85%'}}
                          value={roundDate}
                          onChange={(e) => setRoundDate(e.target.value)}
                        >
                          {rounds.map((item, i) => {
                            return (
                              <option key={i} value={item.value}>
                                {item.value}
                              </option>
                            )
                          })}
                        </select>
                      </div>
                    </Col>
                    <Col sm={6} style={{ margin: '8px 0'}}>
                      <Button variant="primary light" className="w-50" onClick={handleClickDownloadFileTransfer}>
                        ดาวน์โหลด
                      </Button>
                    </Col>
                    <Row>
                    </Row>
                  </Row>
                </Col>
              </Row>
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </Fragment>
  )
}
